import { render, staticRenderFns } from "./experienciaComponent.vue?vue&type=template&id=5864a957&scoped=true&"
import script from "./experienciaComponent.vue?vue&type=script&lang=js&"
export * from "./experienciaComponent.vue?vue&type=script&lang=js&"
import style0 from "./experienciaComponent.vue?vue&type=style&index=0&id=5864a957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864a957",
  null
  
)

export default component.exports